/* eslint-disable no-restricted-globals */
import { Data } from '../../../patterns/commands';
import { SortAndFilterLaborer } from './Laborer';
import { FilterTypes, SortTypes } from '../interfaces';

export type SortAndFilterData = (filterTypes: FilterTypes[], sortTypes: SortTypes[], data: Data) => Data;

/**
 * A function exposed by comlink which will be used to
 * process data off the main thread.
 * @returns Data
 */
export const sortAndFilterData: SortAndFilterData = (filterTypes: FilterTypes[], sortTypes: SortTypes[], data: Data): Data => {
    const laborer = new SortAndFilterLaborer(filterTypes, sortTypes);
    return laborer.processData(data);
};

if (typeof self !== 'undefined') {
    const originalOnMessage = self.onmessage;
    // Expose the processData function to the main thread
    self.onmessage = (event) => {
        if (self.origin.includes('theindependentpharmacy') && event?.data?.filterTypes && event?.data?.sortTypes && event?.data?.data) {
            // Handle incoming messages from the main thread
            const { filterTypes, sortTypes, data } = event.data;
            const result = sortAndFilterData(filterTypes, sortTypes, data);
            self.postMessage(result);
        } else {
            // Pass the message to other extensions
            // eslint-disable-next-line no-lonely-if
            if (typeof originalOnMessage === 'function') {
                originalOnMessage.call(self, event);
            }
        }
    };
}
